<template>
  <div>
    <a-button @click="buttonClick"  :style="{'border-style':borderStyle,'background-color': backgroundColor}">
      {{ $t('page_iot_gateway_transfer_record') }}
    </a-button>
    <a-modal
        v-if="showModel"
        :title="$t('page_iot_gateway_transfer_record')"
        :visible="showModel"
        :body-style="{ padding: '16px 16px 8px' }"
        :destroy-on-close="true"
        :maskClosable="false"
        :width="'50%'"
        :footer="null"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <div v-if="showModel" zIndex="10" style="display: flex;flex-direction: column">
        <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }" >
          <a-col :span="8">
            <a-form-item label="原租户">
              <app-select
                  placeholder="选择原租户"
                  v-model="oldTenantId"
                  style="width: 100%"
                  :list="tenants"
                  :show-search="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="新租户">
              <app-select
                  placeholder="选择新租户"
                  v-model="newTenantId"
                  style="width: 100%"
                  :list="tenants"
                  :show-search="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="网关编号">
              <a-input style="width: 100%"
                       v-model="gatewayCode"
                       prop="true"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="操作用户">
              <a-input style="width: 100%"
                       v-model="createUserName"
                       prop="true"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="选择时间">
              <a-range-picker
                  style="width: 200%"
                  v-model="selectTimeValue"
                  show-time
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :change="onChange()"
              />
            </a-form-item>
          </a-col>

        </a-form>
        <a-button-group style="left:18px;margin-top: 3px;">
          <a-button type="primary" @click="getTableData()">
            {{ $t('search') }}
          </a-button>
          <a-button type="primary" @click="clera()" style="margin-left: 3px;">
            {{ $t('common_reset') }}
          </a-button>
        </a-button-group>
      </div>
      <div>
        <ml-table
            style="margin-top: 5px;table-layout: fixed; text-overflow: clip;"
            :columns="columns"
            :data-source="tableData"
            :pagination="pagination"
            :loading="loading"
            :canChangeColWidth="true"
            @change="handleTableChange"
        >
        </ml-table>
      </div>


    </a-modal>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {TransferRecordServiceProxy,TransferRecordDTO} from "@/service-proxies/app-v2/iot-console.service-proxies";

const escp = new TransferRecordServiceProxy

export default {
  name: "TransferRecord",
  components: {},
  data() {
    return {
      showModel: false,
      selectTimeValue: undefined,
      oldTenantId: undefined,
      newTenantId: undefined,
      gatewayCode: '',
      createUserName: '',
      startTime:'',
      endTime:'',
      form: this.$form.createForm(this),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        size: "normal",
        showSizeChanger: true,
      },
      tableData: [],
      loading: false,
      columns: [
        {
          title: "日期",
          key: "createTime",
          dataIndex: "createTime",
          width: 100,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          title: "网关编号",
          key: "gatewayCode",
          dataIndex: "gatewayCode",
          width: 100,
        },
        {
          title: "原租户",
          key: "oldTenantName",
          dataIndex: "oldTenantName",
          width: 100,
        },
        {
          title: "新租户",
          key: "newTenantName",
          dataIndex: "newTenantName",
          width: 100,
        },
        {
          title: "操作用户",
          key: "createUserName",
          dataIndex: "createUserName",
          width: 100,
        },
      ]
    }
  },
  props: {
    tenants: {},
    borderStyle:{},
    backgroundColor:{}
  },
  created() {
    this.getTransferRecordData()
  },
  methods: {
    buttonClick() {
      this.getTransferRecordData()
      this.showModel = true
    },
    handleCancel() {
      this.showModel = false
      this.alertVisible = false
      this.startTime = undefined
      this.endTime = undefined
      this.oldTenantId = undefined
      this.newTenantId = undefined
      this.gatewayCode = ''
      this.createUserName = ''
      this.selectTimeValue= undefined
    },
    handleOk() {
      this.showModel = false
    },
    handleTableChange(e) {
      if (e) {
        this.pagination.current = e.current
        this.pagination.pageSize = e.pageSize
      }
      this.getTransferRecordData()
    },
    getTableData() {
      this.pagination.current = 1
      this.getTransferRecordData()
    },
    getTransferRecordData(){
      this.loading = true
      let params = {
        current : this.pagination.current,
        size : this.pagination.pageSize,
        oldTenantId : this.oldTenantId,
        newTenantId : this.newTenantId,
        startTime : this.startTime,
        endTime : this.endTime,
        createUserName : this.createUserName,
        gatewayCode : this.gatewayCode,
      }
      const gs = new TransferRecordDTO()
      gs.init(params)
      escp.getGatewayTransferRecord(gs).then((res) => {
        if (res){
          this.tableData = res.list
          this.pagination.total = res.totalCount
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    clera() {
      this.startTime = undefined
      this.endTime = undefined
      this.oldTenantId = undefined
      this.newTenantId = undefined
      this.gatewayCode = ''
      this.createUserName = ''
      this.selectTimeValue= undefined
    },
    onChange(){
      if (this.selectTimeValue && this.selectTimeValue.length > 0){
        this.startTime = this.selectTimeValue[0]
        this.endTime =this.selectTimeValue[1]
      }else{
        this.startTime = ''
        this.endTime = ''
      }
    }
  }
}
</script>

<style scoped>

</style>